function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "menu_utenti");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "menu_utenti",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon/original/profilo_85pt-copy-17",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "a_1410_minus"
}), /*#__PURE__*/React.createElement("g", {
  id: "0317_person_100pt",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.71256881,15.0076758 L4.93784913,15.0076758 C2.22098879,15.0076758 0.0105504587,17.2188175 0.0105504587,19.9368502 L0.0105504587,21.8160041 C0.0105504587,22.4634327 0.535395057,22.9882772 1.18282365,22.9882772 C1.83025224,22.9882772 2.35509684,22.4634327 2.35509684,21.8160041 L2.35509684,19.9368502 C2.35612964,18.5105597 3.51155979,17.3542904 4.93784913,17.3522222 L8.71256881,17.3522222 C9.3599974,17.3522222 9.884842,16.8273776 9.884842,16.179949 C9.884842,15.5325204 9.3599974,15.0076758 8.71256881,15.0076758 L8.71256881,15.0076758 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8382467,6.37130479 L17.8382467,6.30800204 C17.8382467,4.62438328 17.177788,3.04204893 15.978318,1.85336391 C13.4971748,-0.600506412 9.50329413,-0.600506412 7.02215087,1.85336391 C5.82268094,3.04298675 5.16222222,4.6253211 5.16222222,6.30800204 L5.16222222,6.37130479 C5.16222222,8.05468909 5.82268094,9.63702345 7.02215087,10.8259429 C9.50329413,13.2798132 13.4971748,13.2798132 15.978318,10.8259429 C17.177788,9.63608563 17.8382467,8.05468909 17.8382467,6.37130479 Z M15.4937003,6.37130479 C15.4937003,8.55009174 13.7022324,10.3228033 11.5,10.3228033 C9.29776758,10.3228033 7.50606524,8.55009174 7.50606524,6.37130479 L7.50606524,6.30800204 C7.50606524,4.12898063 9.29776758,2.35626911 11.5,2.35626911 C13.7022324,2.35626911 15.4937003,4.12898063 15.4937003,6.30800204 L15.4937003,6.37130479 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8160041,16.8910499 L19.2386442,16.8910499 L19.2386442,14.3134557 C19.2386442,13.6660271 18.7137996,13.1411825 18.066371,13.1411825 C17.4189425,13.1411825 16.8940979,13.6660271 16.8940979,14.3134557 L16.8940979,16.8910499 L14.3134557,16.8910499 C13.6660271,16.8910499 13.1411825,17.4158945 13.1411825,18.0633231 C13.1411825,18.7107517 13.6660271,19.2355963 14.3134557,19.2355963 L16.8940979,19.2355963 L16.8940979,21.8160041 C16.8940979,22.4634327 17.4189425,22.9882773 18.066371,22.9882773 C18.7137996,22.9882773 19.2386442,22.4634327 19.2386442,21.8160041 L19.2386442,19.2355963 L21.8160041,19.2355963 C22.4634327,19.2355963 22.9882773,18.7107517 22.9882773,18.0633231 C22.9882773,17.4158945 22.4634327,16.8910499 21.8160041,16.8910499 Z",
  id: "Path"
})))));

var SvgMenuUsers = function SvgMenuUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu_users.870a66b7.svg";
export { ForwardRef as ReactComponent };